<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import TabBarMobile from './mobile.vue'
import TabBarPc from './pc.vue'

const appStore = useAppStore()
</script>

<template>
  <template v-if="appStore.shouldShowTabBar">
    <TabBarMobile v-if="appStore.isMobile" />
    <TabBarPc v-else />
  </template>
</template>
